import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-set-send-limit',
  templateUrl: './set-send-limit.component.html',
  styleUrls: ['./set-send-limit.component.scss'],
})
export class SetSendLimitComponent implements OnInit {
  sendLimit: number;
  inputForm: FormGroup;

  constructor() {}

  ngOnInit(): void {
    this.inputForm.addControl(
      'limit',
      new FormControl(this.sendLimit ?? '', [Validators.required])
    );
  }
}
